function getTimezoneOffset(timeZone: string) {
  try {
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone,
      timeZoneName: 'shortOffset',
    })
    const parts = formatter.formatToParts(new Date())
    const offsetPart = parts.find((part) => part.type === 'timeZoneName')
    return offsetPart?.value || 'UTC+0'
  } catch {
    return ''
  }
}

export const TIME_ZONES = [
  'America/Ciudad_Juarez',
  'Australia/ACT',
  'Australia/Victoria',
  'Asia/Choibalsan',
  'Etc/GMT-7',
  'America/Thule',
  'Australia/Broken_Hill',
  'Asia/Calcutta',
  'America/North_Dakota/Center',
  'Etc/Universal',
  'EST5EDT',
  'Europe/Ljubljana',
  'America/Indiana/Marengo',
  'Atlantic/Bermuda',
  'America/Winnipeg',
  'GMT',
  'America/Blanc-Sablon',
  'US/Pacific',
  'Mexico/BajaSur',
  'Pacific/Nauru',
  'Africa/Khartoum',
  'Australia/Sydney',
  'Asia/Taipei',
  'MST7MDT',
  'America/Noronha',
  'America/Havana',
  'America/Santa_Isabel',
  'Australia/West',
  'America/Rankin_Inlet',
  'Asia/Dacca',
  'America/Belize',
  'Europe/Copenhagen',
  'CET',
  'America/Argentina/San_Juan',
  'PST8PDT',
  'America/Tortola',
  'Etc/GMT+4',
  'Asia/Istanbul',
  'Pacific/Norfolk',
  'Indian/Christmas',
  'Pacific/Rarotonga',
  'America/Guyana',
  'Indian/Reunion',
  'America/Merida',
  'GB-Eire',
  'Australia/NSW',
  'Etc/GMT+3',
  'Africa/Addis_Ababa',
  'Etc/Zulu',
  'America/Campo_Grande',
  'Europe/Mariehamn',
  'America/Eirunepe',
  'America/Menominee',
  'America/Argentina/Cordoba',
  'Africa/Libreville',
  'America/Cambridge_Bay',
  'America/Godthab',
  'Africa/Lome',
  'Pacific/Marquesas',
  'Etc/GMT-13',
  'Australia/Yancowinna',
  'America/Boa_Vista',
  'PRC',
  'US/Hawaii',
  'Australia/Adelaide',
  'Asia/Pontianak',
  'Africa/Lusaka',
  'Pacific/Fakaofo',
  'Etc/GMT-5',
  'Pacific/Pohnpei',
  'Australia/Currie',
  'Asia/Macao',
  'UCT',
  'America/Port_of_Spain',
  'America/Porto_Velho',
  'Asia/Gaza',
  'Etc/GMT-6',
  'Atlantic/Faroe',
  'America/Montserrat',
  'Africa/Lagos',
  'Pacific/Tarawa',
  'America/Punta_Arenas',
  'Asia/Yangon',
  'America/Kralendijk',
  'Pacific/Efate',
  'US/Michigan',
  'Antarctica/Macquarie',
  'Pacific/Wallis',
  'Atlantic/Azores',
  'Europe/Podgorica',
  'Pacific/Fiji',
  'America/Regina',
  'Etc/GMT0',
  'Asia/Kuwait',
  'Asia/Ujung_Pandang',
  'Europe/Prague',
  'Africa/Gaborone',
  'Antarctica/Casey',
  'America/Scoresbysund',
  'America/Coral_Harbour',
  'America/Ojinaga',
  'EST',
  'America/Adak',
  'America/Montreal',
  'Europe/Belgrade',
  'Africa/Kinshasa',
  'America/Bahia',
  'Africa/Bujumbura',
  'America/Dawson',
  'America/Curacao',
  'Asia/Riyadh',
  'America/Edmonton',
  'America/Fort_Wayne',
  'Asia/Aqtobe',
  'Africa/Nairobi',
  'America/Bahia_Banderas',
  'America/Atka',
  'Europe/Guernsey',
  'America/Indiana/Winamac',
  'Atlantic/Reykjavik',
  'Europe/Andorra',
  'Atlantic/Stanley',
  'Australia/Hobart',
  'Europe/Belfast',
  'Europe/Zagreb',
  'Africa/Brazzaville',
  'America/Vancouver',
  'America/St_Barthelemy',
  'America/Catamarca',
  'America/Whitehorse',
  'Asia/Saigon',
  'Europe/Simferopol',
  'Pacific/Tahiti',
  'EET',
  'Asia/Novosibirsk',
  'Europe/Budapest',
  'Asia/Qyzylorda',
  'Europe/Lisbon',
  'America/Knox_IN',
  'Asia/Phnom_Penh',
  'Antarctica/Rothera',
  'America/Moncton',
  'Asia/Vladivostok',
  'Europe/Zaporozhye',
  'US/Samoa',
  'Asia/Tokyo',
  'Atlantic/South_Georgia',
  'Antarctica/DumontDUrville',
  'America/Sitka',
  'America/Argentina/Mendoza',
  'America/Maceio',
  'Africa/Windhoek',
  'Pacific/Saipan',
  'America/Tijuana',
  'Brazil/DeNoronha',
  'Africa/El_Aaiun',
  'Asia/Tehran',
  'America/St_Kitts',
  'America/Managua',
  'Brazil/West',
  'GMT0',
  'Kwajalein',
  'Asia/Anadyr',
  'Europe/Oslo',
  'Indian/Mayotte',
  'Etc/GMT+10',
  'Europe/Jersey',
  'America/New_York',
  'Asia/Yakutsk',
  'Asia/Katmandu',
  'America/Chihuahua',
  'Asia/Macau',
  'Greenwich',
  'Pacific/Easter',
  'America/Coyhaique',
  'Africa/Ouagadougou',
  'America/Mazatlan',
  'Asia/Irkutsk',
  'Africa/Malabo',
  'America/Chicago',
  'Europe/Tirane',
  'Europe/Rome',
  'America/Paramaribo',
  'America/Rio_Branco',
  'Etc/GMT-1',
  'America/Jamaica',
  'Europe/Saratov',
  'Atlantic/St_Helena',
  'Pacific/Honolulu',
  'Australia/Queensland',
  'Pacific/Pago_Pago',
  'Europe/Volgograd',
  'Australia/North',
  'Pacific/Tongatapu',
  'Africa/Johannesburg',
  'Africa/Lubumbashi',
  'Africa/Blantyre',
  'America/Thunder_Bay',
  'Etc/GMT+7',
  'America/Atikokan',
  'America/Jujuy',
  'Asia/Kuala_Lumpur',
  'Africa/Tripoli',
  'Australia/Canberra',
  'Etc/GMT-4',
  'Pacific/Funafuti',
  'America/Hermosillo',
  'Antarctica/Vostok',
  'Japan',
  'Africa/Dakar',
  'Hongkong',
  'America/Fortaleza',
  'Australia/Lindeman',
  'America/Los_Angeles',
  'Asia/Makassar',
  'Chile/EasterIsland',
  'America/Nome',
  'America/Guayaquil',
  'America/St_Johns',
  'Asia/Colombo',
  'America/North_Dakota/Beulah',
  'Australia/Brisbane',
  'Europe/Vienna',
  'America/St_Vincent',
  'Africa/Kampala',
  'Asia/Kolkata',
  'Asia/Samarkand',
  'Canada/Eastern',
  'Etc/GMT+11',
  'Europe/Isle_of_Man',
  'America/Buenos_Aires',
  'Etc/GMT-2',
  'Atlantic/Jan_Mayen',
  'America/Denver',
  'Etc/GMT+6',
  'Mexico/BajaNorte',
  'NZ-CHAT',
  'US/Mountain',
  'Africa/Ndjamena',
  'America/Kentucky/Monticello',
  'America/Costa_Rica',
  'America/Metlakatla',
  'Asia/Bahrain',
  'Africa/Tunis',
  'America/Martinique',
  'Africa/Maputo',
  'Asia/Jayapura',
  'Asia/Bangkok',
  'America/Puerto_Rico',
  'Europe/Moscow',
  'HST',
  'America/La_Paz',
  'Pacific/Port_Moresby',
  'Asia/Chongqing',
  'Asia/Beirut',
  'Asia/Novokuznetsk',
  'Pacific/Yap',
  'Australia/South',
  'Asia/Rangoon',
  'Africa/Juba',
  'Europe/Sofia',
  'America/Guatemala',
  'Australia/Eucla',
  'CST6CDT',
  'Navajo',
  'GB',
  'Pacific/Noumea',
  'US/Alaska',
  'Atlantic/Cape_Verde',
  'Asia/Hebron',
  'America/Nipigon',
  'Atlantic/Canary',
  'Asia/Hovd',
  'America/Indiana/Vincennes',
  'America/Sao_Paulo',
  'America/Ensenada',
  'America/Recife',
  'Asia/Jakarta',
  'Indian/Chagos',
  'America/Cuiaba',
  'America/Matamoros',
  'America/Antigua',
  'America/Santo_Domingo',
  'America/St_Thomas',
  'NZ',
  'Europe/Bratislava',
  'Canada/Yukon',
  'Europe/Paris',
  'Asia/Qatar',
  'Europe/Kirov',
  'America/St_Lucia',
  'America/Cordoba',
  'Etc/Greenwich',
  'Africa/Bangui',
  'America/Argentina/La_Rioja',
  'America/Argentina/Tucuman',
  'America/Port-au-Prince',
  'Asia/Aden',
  'Pacific/Niue',
  'Europe/Istanbul',
  'Atlantic/Faeroe',
  'US/Indiana-Starke',
  'Canada/Newfoundland',
  'America/Swift_Current',
  'Europe/Tiraspol',
  'America/Boise',
  'Etc/GMT+8',
  'Africa/Bissau',
  'America/Glace_Bay',
  'Asia/Ulaanbaatar',
  'Asia/Manila',
  'America/Goose_Bay',
  'Asia/Karachi',
  'America/Cancun',
  'Asia/Qostanay',
  'Asia/Thimphu',
  'Europe/San_Marino',
  'Etc/GMT+5',
  'Indian/Maldives',
  'Antarctica/Syowa',
  'Africa/Asmara',
  'ROC',
  'America/Asuncion',
  'Europe/Madrid',
  'Africa/Kigali',
  'America/Argentina/Jujuy',
  'Africa/Monrovia',
  'Australia/Darwin',
  'Etc/GMT',
  'Africa/Maseru',
  'Africa/Dar_es_Salaam',
  'Asia/Yerevan',
  'Europe/Kyiv',
  'America/El_Salvador',
  'America/Indiana/Indianapolis',
  'America/Belem',
  'Asia/Shanghai',
  'Pacific/Chatham',
  'Africa/Porto-Novo',
  'Africa/Asmera',
  'Pacific/Apia',
  'Africa/Cairo',
  'Europe/Vilnius',
  'Asia/Tomsk',
  'America/Detroit',
  'Pacific/Guam',
  'Africa/Harare',
  'America/Lima',
  'Asia/Aqtau',
  'Asia/Seoul',
  'Australia/Tasmania',
  'America/Miquelon',
  'Brazil/Acre',
  'Singapore',
  'Etc/UTC',
  'ROK',
  'Europe/Athens',
  'Pacific/Enderbury',
  'America/North_Dakota/New_Salem',
  'Asia/Pyongyang',
  'Asia/Chungking',
  'Europe/Helsinki',
  'America/Nassau',
  'Asia/Tbilisi',
  'Africa/Mbabane',
  'UTC',
  'Etc/GMT+2',
  'America/Guadeloupe',
  'Factory',
  'Egypt',
  'Brazil/East',
  'Indian/Mauritius',
  'Europe/Stockholm',
  'America/Anchorage',
  'Etc/GMT+9',
  'Asia/Damascus',
  'Africa/Ceuta',
  'Asia/Ashkhabad',
  'Etc/GMT+1',
  'Europe/Ulyanovsk',
  'Africa/Luanda',
  'Pacific/Auckland',
  'America/Bogota',
  'Antarctica/McMurdo',
  'Indian/Kerguelen',
  'Africa/Djibouti',
  'Atlantic/Madeira',
  'Turkey',
  'America/Louisville',
  'America/Caracas',
  'Asia/Srednekolymsk',
  'Asia/Ust-Nera',
  'Europe/Amsterdam',
  'Europe/Luxembourg',
  'Pacific/Bougainville',
  'Europe/Berlin',
  'America/Danmarkshavn',
  'Europe/Brussels',
  'Europe/Kaliningrad',
  'Africa/Bamako',
  'America/Dominica',
  'Europe/Kiev',
  'Pacific/Midway',
  'Europe/Astrakhan',
  'America/Argentina/Ushuaia',
  'Asia/Ho_Chi_Minh',
  'America/Shiprock',
  'America/Cayenne',
  'Africa/Accra',
  'Europe/Malta',
  'Pacific/Samoa',
  'America/Resolute',
  'Europe/Skopje',
  'America/Aruba',
  'Europe/Vatican',
  'Asia/Kuching',

  'Etc/GMT-9',
  'Etc/GMT+0',
  'Asia/Vientiane',
  'US/Central',
  'Europe/Samara',
  'Africa/Abidjan',
  'America/Grenada',
  'Asia/Jerusalem',
  'Asia/Urumqi',
  'Asia/Tashkent',
  'Asia/Singapore',
  'Pacific/Kiritimati',
  'Africa/Algiers',
  'America/Nuuk',
  'Canada/Atlantic',
  'Europe/Bucharest',
  'Etc/UCT',
  'Pacific/Gambier',
  'America/Mendoza',
  'Pacific/Kosrae',
  'Pacific/Wake',
  'Chile/Continental',
  'Asia/Hong_Kong',
  'Antarctica/Mawson',
  'America/Indiana/Tell_City',
  'America/Argentina/Rio_Gallegos',
  'Etc/GMT-0',
  'Pacific/Ponape',
  'America/Panama',
  'MST',
  'Canada/Saskatchewan',
  'Africa/Sao_Tome',
  'Jamaica',
  'America/Iqaluit',
  'Canada/Central',
  'Poland',
  'Antarctica/South_Pole',
  'Africa/Mogadishu',
  'Etc/GMT-14',
  'Africa/Nouakchott',
  'Antarctica/Davis',
  'America/Juneau',
  'Africa/Timbuktu',
  'America/Mexico_City',
  'Pacific/Majuro',
  'America/Grand_Turk',
  'MET',
  'Africa/Casablanca',
  'Africa/Banjul',
  'US/Eastern',
  'Asia/Atyrau',
  'Europe/Minsk',
  'America/Phoenix',
  'Pacific/Johnston',
  'Pacific/Kanton',
  'Asia/Omsk',
  'Europe/Warsaw',
  'America/Indiana/Petersburg',
  'America/Dawson_Creek',
  'Asia/Kathmandu',
  'Asia/Famagusta',
  'America/Argentina/Catamarca',
  'Etc/GMT+12',
  'Africa/Douala',
  'Asia/Tel_Aviv',
  'Etc/GMT-11',
  'Antarctica/Troll',
  'Indian/Mahe',
  'Indian/Antananarivo',
  'Europe/Gibraltar',
  'Cuba',
  'Europe/Tallinn',
  'Asia/Baku',
  'US/East-Indiana',
  'Africa/Conakry',
  'Europe/Monaco',
  'Asia/Sakhalin',
  'Australia/Melbourne',
  'Iceland',
  'America/Virgin',
  'America/Fort_Nelson',
  'Asia/Krasnoyarsk',
  'America/Anguilla',
  'Asia/Oral',
  'Asia/Yekaterinburg',
  'America/Argentina/San_Luis',
  'Europe/London',
  'America/Yellowknife',
  'Europe/Busingen',
  'Asia/Dhaka',
  'Pacific/Kwajalein',
  'Asia/Muscat',
  'Europe/Riga',
  'Canada/Pacific',
  'Asia/Khandyga',
  'America/Indiana/Knox',
  'Asia/Magadan',
  'America/Pangnirtung',
  'America/Yakutat',
  'Asia/Bishkek',
  'Asia/Dili',
  'America/Lower_Princes',
  'America/Tegucigalpa',
  'America/Porto_Acre',
  'Etc/GMT-8',
  'America/Montevideo',
  'Europe/Dublin',
  'Asia/Brunei',
  'America/Inuvik',
  'Asia/Almaty',
  'Pacific/Chuuk',
  'America/Marigot',
  'US/Arizona',
  'America/Kentucky/Louisville',
  'America/Rosario',
  'Etc/GMT-12',
  'America/Argentina/Salta',
  'Asia/Ashgabat',
  'Etc/GMT-3',
  'Arctic/Longyearbyen',
  'America/Barbados',
  'Australia/Perth',
  'Asia/Harbin',
  'Portugal',
  'Mexico/General',
  'America/Halifax',
  'Asia/Ulan_Bator',
  'America/Santarem',
  'Asia/Chita',
  'America/Creston',
  'America/Rainy_River',
  'GMT-0',
  'Canada/Mountain',
  'Pacific/Galapagos',
  'Pacific/Palau',
  'America/Indiana/Vevay',
  'Asia/Thimbu',
  'Etc/GMT-10',
  'Asia/Dushanbe',
  'America/Argentina/ComodRivadavia',
  'Europe/Chisinau',
  'America/Cayman',
  'America/Indianapolis',
  'Asia/Dubai',
  'Asia/Barnaul',
  'Asia/Nicosia',
  'Africa/Freetown',
  'Pacific/Pitcairn',
  'Pacific/Truk',
  'Antarctica/Palmer',
  'Europe/Sarajevo',
  'Europe/Nicosia',
  'Australia/Lord_Howe',
  'America/Monterrey',
  'Asia/Baghdad',
  'Israel',
  'America/Manaus',
  'America/Araguaina',
  'Europe/Uzhgorod',
  'America/Santiago',
  'Eire',
  'Asia/Kamchatka',
  'Europe/Vaduz',
  'Iran',
  'Asia/Amman',
  'Asia/Kabul',
  'Zulu',
  'Libya',
  'Pacific/Guadalcanal',
  'GMT+0',
  'Universal',
  'America/Toronto',
  'Indian/Comoro',
  'Asia/Kashgar',
  'WET',
  'Indian/Cocos',
  'US/Aleutian',
  'Africa/Niamey',
  'Australia/LHI',
  'Europe/Zurich',
  'America/Argentina/Buenos_Aires',
  'W-SU',
]

export const TIME_ZONES_GROUPED = [
  {
    label: 'America',
    options: TIME_ZONES.filter((z) => z.startsWith('America/')).map((z) => ({
      label: `${getTimezoneOffset(String(z))} ${String(z)}`,
      value: String(z),
    })),
  },
  {
    label: 'Europe',
    options: TIME_ZONES.filter((z) => z.startsWith('Europe/')).map((z) => ({
      label: `${getTimezoneOffset(String(z))} ${String(z)}`,
      value: String(z),
    })),
  },
  {
    label: 'Asia',
    options: TIME_ZONES.filter((z) => z.startsWith('Asia/')).map((z) => ({
      label: `${getTimezoneOffset(String(z))} ${String(z)}`,
      value: String(z),
    })),
  },
  {
    label: 'Africa',
    options: TIME_ZONES.filter((z) => z.startsWith('Africa/')).map((z) => ({
      label: `${getTimezoneOffset(String(z))} ${String(z)}`,
      value: String(z),
    })),
  },
  {
    label: 'Pacific',
    options: TIME_ZONES.filter((z) => z.startsWith('Pacific/')).map((z) => ({
      label: `${getTimezoneOffset(String(z))} ${String(z)}`,
      value: String(z),
    })),
  },
  {
    label: 'Atlantic',
    options: TIME_ZONES.filter((z) => z.startsWith('Atlantic/')).map((z) => ({
      label: `${getTimezoneOffset(String(z))} ${String(z)}`,
      value: String(z),
    })),
  },
  {
    label: 'Indian',
    options: TIME_ZONES.filter((z) => z.startsWith('Indian/')).map((z) => ({
      label: `${getTimezoneOffset(String(z))} ${String(z)}`,
      value: String(z),
    })),
  },
  {
    label: 'Antarctica',
    options: TIME_ZONES.filter((z) => z.startsWith('Antarctica/')).map((z) => ({
      label: `${getTimezoneOffset(String(z))} ${String(z)}`,
      value: String(z),
    })),
  },
  {
    label: 'Australia',
    options: TIME_ZONES.filter((z) => z.startsWith('Australia/')).map((z) => ({
      label: `${getTimezoneOffset(String(z))} ${String(z)}`,
      value: String(z),
    })),
  },
  {
    label: 'UTC/Other',
    options: [{ label: 'UTC Time', value: 'UTC' }],
  },
]
